export default {
  cityName: '',
  selectedCity: '',
  localAddress: null,
  positionStaus: false,
  // addressInfo: null,
  province: '',
  city: '',
  district: '',
  nearBy: [],
  current: null
};



// WEBPACK FOOTER //
// ./src/stores/location/_state.js